import React from "react";
import { Table, Button, Form, FormControl, Spinner } from "react-bootstrap";
import { saveAs } from 'file-saver';

export default function InvoicesTable({ 
  invoices, invoiceCount,
  handleViewPDFInvoice, 
  loadingInvoiceId, 
  handleSearch, 
  searchQuery,
  currentPage,
  totalPages,
  handlePrevPage,
  handleNextPage,
  startIndex,
  endIndex,
  loading,
  dateFilter,
  handleDateFilterChange,
  exportData
}) {
  // Only export the filtered or paginated invoices
  const exportCSV = () => {
    const dataToExport = exportData && exportData.length > 0 ? exportData : invoices;
    const csvRows = [
      ['Invoice No.', 'Tenant', 'Unit Number', 'Invoice Date', 'Invoice Status', 'Invoice Amount'],
      ...dataToExport
        .sort((a, b) => b.id - a.id)
        .map((invoice) => [
          `INV ${invoice.invoice_number}`,
          invoice.tenant,
          invoice.house,
          invoice.invoice_date,
          invoice.invoice_status,
          `KSH. ${parseInt(invoice.amount).toLocaleString('en-us')}`
        ]),
    ];
    const csvString = csvRows.map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(',')).join('\n');
    const csvBlob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    saveAs(csvBlob, 'tenant_invoices.csv');
  };
  console.log("invoices", invoices);

  return (
    <div className="">
      <h5 className="mb-3 mt-3">List of Tenant Invoices</h5>

      <div className="d-block mb-3">
        <div className='d-flex justify-content-between align-items-end'>
          <Button className='btn btn-success text-white me-3' onClick={exportCSV}> 
            EXCEL <i className='bi bi-file-earmark-excel'></i>
          </Button>
          <div className="d-flex align-items-end">
            <Form className="me-2">
              <FormControl
                type="date"
                name="from"
                value={dateFilter?.from || ''}
                onChange={handleDateFilterChange}
                size="sm"
              />
            </Form>
            <Form className="me-2">
              <FormControl
                type="date"
                name="to"
                value={dateFilter?.to || ''}
                onChange={handleDateFilterChange}
                size="sm"
              />
            </Form>
            <Form className="searchBar">
              <FormControl 
                type="text" 
                placeholder="Search" 
                value={searchQuery}
                onChange={handleSearch} 
              />
            </Form>
          </div>
        </div>
      </div>
      
      <div className="position-relative">
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0, left: 0, right: 0, bottom: 0,
              background: "rgba(255,255,255,0.7)",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Spinner animation="border" variant="primary" />
            <span className="ms-2">Loading...</span>
          </div>
        )}
        <Table className="table">
          <thead>
            <tr>
              <th>Invoice No.</th>
              <th>Tenant</th>
              <th>Unit Number</th>
              <th>Invoice Date</th>
              <th>Invoice Status</th>
              <th>Invoice Amount</th>
              <th>View Invoice</th>
            </tr>
          </thead>
          <tbody>
            {invoices.length > 0 ? (
              invoices
                .sort((a, b) => b.id - a.id)
                .map((invoice) => (
                  <tr key={invoice.id}>
                    <td>INV {invoice.invoice_number}</td>
                    <td>{invoice.tenant}</td>
                    <td>{invoice.house}</td>
                    <td>{invoice.invoice_date}</td>
                    <td>
                      <span
                        className={`badge p-2 ${
                          invoice.invoice_status === "paid"
                            ? "bg-success"
                            : invoice.invoice_status === "unpaid"
                              ? "bg-danger"
                              : "bg-secondary"
                        }`}
                      >
                        {invoice.invoice_status}
                      </span>
                    </td>
                    <td>KSH. {parseInt(invoice.amount).toLocaleString('en-us')}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => handleViewPDFInvoice(invoice.id)}
                        disabled={loadingInvoiceId === invoice.id}
                      >
                        {loadingInvoiceId === invoice.id ? "Loading..." : "View Rent Inv"}
                      </button>
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">No invoices generated at the moment.</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="pagination">
        <button onClick={handlePrevPage} disabled={currentPage === 0}>
          &lt;
        </button>
        <span>{`${startIndex + 1}-${endIndex} of ${invoiceCount}`}</span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages - 1}>
          &gt;
        </button>
      </div>
    </div>
  );
}